enum Currency {
    EUR = 'EUR',
    GBP = 'GBP',
    DKK = 'DKK',
    SEK = 'SEK',
    NOK = 'NOK',
}

export default Currency
